/**
 * Sticky Buy Button - Mobile Only
 * Makes the add to cart button stick to the bottom when scrolled past
 */

class StickyBuyButton {
  constructor() {
    this.init();
  }

  init() {
    // Only run on mobile devices
    if (window.innerWidth > 749) {
      return;
    }

    // Find the original buy button
    this.originalButton = document.querySelector('.product-form__submit');
    
    if (!this.originalButton) {
      return;
    }

    // Create sticky button wrapper
    this.createStickyButton();

    // Set up Intersection Observer
    this.setupObserver();

    // Handle window resize
    this.handleResize();
  }

  createStickyButton() {
    // Clone the original button
    const buttonClone = this.originalButton.cloneNode(true);
    
    // Create wrapper for sticky button
    this.stickyWrapper = document.createElement('div');
    this.stickyWrapper.className = 'sticky-buy-button-wrapper';
    
    // Append cloned button to wrapper
    this.stickyWrapper.appendChild(buttonClone);
    
    // Add to body
    document.body.appendChild(this.stickyWrapper);

    // Copy form functionality to cloned button
    this.setupButtonFunctionality(buttonClone);
  }

  setupButtonFunctionality(clonedButton) {
    // When sticky button is clicked, trigger the original button
    clonedButton.addEventListener('click', (e) => {
      e.preventDefault();
      
      // Find the original form and submit it
      const productForm = document.querySelector('product-form form');
      if (productForm) {
        // Trigger the original button click
        this.originalButton.click();
      }
    });
  }

  setupObserver() {
    // Create an intersection observer
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Original button is visible - hide sticky button
          this.hideStickyButton();
        } else {
          // Original button is not visible - show sticky button
          this.showStickyButton();
        }
      });
    }, options);

    // Observe the original button's container
    const buttonContainer = this.originalButton.closest('.product-form__buttons');
    if (buttonContainer) {
      this.observer.observe(buttonContainer);
    }
  }

  showStickyButton() {
    if (this.stickyWrapper) {
      this.stickyWrapper.classList.add('is-visible');
    }
  }

  hideStickyButton() {
    if (this.stickyWrapper) {
      this.stickyWrapper.classList.remove('is-visible');
    }
  }

  handleResize() {
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        // If window is resized to desktop, remove sticky button
        if (window.innerWidth > 749) {
          if (this.stickyWrapper) {
            this.stickyWrapper.remove();
          }
          if (this.observer) {
            this.observer.disconnect();
          }
        } else {
          // If resized back to mobile and sticky button doesn't exist, reinitialize
          if (!this.stickyWrapper || !document.body.contains(this.stickyWrapper)) {
            this.init();
          }
        }
      }, 250);
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new StickyBuyButton();
  });
} else {
  new StickyBuyButton();
}

// Reinitialize on variant change (for Shopify dynamic variant changes)
document.addEventListener('variant:change', () => {
  // Small delay to ensure DOM has updated
  setTimeout(() => {
    const existingStickyButton = document.querySelector('.sticky-buy-button-wrapper .product-form__submit');
    const originalButton = document.querySelector('.product-form__submit');
    
    if (existingStickyButton && originalButton) {
      // Update sticky button text and attributes to match original
      existingStickyButton.innerHTML = originalButton.innerHTML;
      existingStickyButton.disabled = originalButton.disabled;
      
      // Copy classes
      existingStickyButton.className = originalButton.className;
    }
  }, 100);
});